import { useEffect, useState } from 'react';
import { Fade, Grid, useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { useDispatch, useSelector } from 'store';
import { closeSnackbar } from 'store/slices/snackbar';
import {
    CountdownContainer,
    CountdownMessage,
    MessageContainer,
    SnackbarContainer,
    SnackbarSubtitle,
    SnackbarTitle,
    SubtitleContainer
} from './components';

// ==============================|| SNACKBAR ||============================== //

const Snackbar = () => {
    const { palette } = useTheme();
    const dispatch = useDispatch();
    const snackbar = useSelector((state) => state.snackbar);
    const { open, title, subtitle, type } = snackbar;
    const [countdown, setCountdown] = useState(5);

    const getBackgroundColorByType = () => {
        console.log('palette', palette);
        switch (type) {
            case 'success':
                return palette.otherSuccess.light;
            case 'error':
                return palette.otherError.light;
            case 'warning':
                return palette.otherWarning.light;
            default:
                return palette.otherSuccess.light;
        }
    };

    useEffect(() => {
        if (open) {
            setCountdown(5);
            const timer = setInterval(() => {
                setCountdown((prev) => {
                    if (prev <= 1) {
                        dispatch(closeSnackbar());
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);

            return () => clearInterval(timer);
        }
        return undefined;
    }, [open, dispatch]);

    return (
        <Fade in={open}>
            <SnackbarContainer component={Grid} container>
                <MessageContainer>
                    <SnackbarTitle>{title}</SnackbarTitle>
                    <SubtitleContainer bgColor={getBackgroundColorByType()}>
                        <SnackbarSubtitle>{subtitle}</SnackbarSubtitle>
                    </SubtitleContainer>
                </MessageContainer>
                <CountdownContainer>
                    <CountdownMessage>
                        <FormattedMessage id="thisMessageWillDisappearIn" /> ... <strong>{countdown}</strong>{' '}
                        {countdown === 1 ? <FormattedMessage id="second" /> : <FormattedMessage id="seconds" />}
                    </CountdownMessage>
                </CountdownContainer>
            </SnackbarContainer>
        </Fade>
    );
};

export default Snackbar;
